'use strict';

import React from 'react';
import * as d3request from 'd3-request';

class GoogleAnalytics extends React.Component {

  constructor(state) {
    super(state);

    this.state = {
      ... state
    }
  }

  componentDidMount() {

    let hostname = window.location.hostname;

    // to avoid a error message on localhost
    if (hostname == 'localhost') {
      //hostname = 'www.tagesanzeiger.ch';
      return;
    }

    hostname =
      hostname.substring(hostname.lastIndexOf('.',
          hostname.lastIndexOf('.') - 1) + 1); // extract domain name from host
                                               // (crops subdomains like
                                               // interaktiv.)

    //TODO Move this request to Statistics component – no need to do the
    // same request twice
    d3request.json('http://www.' + hostname + '/api/sites/default')
      .get((error, siteData) => {

        siteData.site.google_analytics_information.trackers.map((tracker) => {
          // When creating more than one tracker, each tracker needs to be
          // given its own name, otherwise just one tracker will be created
          ga('create', tracker.id, 'auto', tracker.name);
          // When a tracker sends a command, it will have to send the
          // command prefixed with the tracker name, so it will work correctly.
          ga(`${tracker.name}.send`, 'pageview');
        });
      });
  }

  render () {
    return null;
  }

}

GoogleAnalytics.propTypes = {};

GoogleAnalytics.defaultProps = {};

export default GoogleAnalytics;



/** WEBPACK FOOTER **
 ** ./src/components/googleAnalytics/GoogleAnalytics.js
 **/